import { render, staticRenderFns } from "./caseQuestionMCQ.vue?vue&type=template&id=43e0d67a"
import script from "./caseQuestionMCQ.vue?vue&type=script&lang=js"
export * from "./caseQuestionMCQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports